import { render, staticRenderFns } from "./FullStudentDetail.vue?vue&type=template&id=5ef2af6f&scoped=true&"
import script from "./FullStudentDetail.vue?vue&type=script&lang=js&"
export * from "./FullStudentDetail.vue?vue&type=script&lang=js&"
import style0 from "./FullStudentDetail.vue?vue&type=style&index=0&id=5ef2af6f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef2af6f",
  null
  
)

export default component.exports